import React from 'react'

export default function IconBadge({ label, color, className = '', children }) {
  return (
    <div
      className={`w-20 h-20 ${color} rounded-full flex items-center justify-center ${className}`.trim()}
      role="img"
      aria-label={label}
    >
      {children}
    </div>
  )
}
